import { Vector3 } from 'three';

import { camera } from './scene';
import { isDebugging } from './urlParams';

if (isDebugging) {
  document.addEventListener('wheel', (event: WheelEvent) => {
    const rotation = camera.quaternion;
    const newPosition = camera.position.clone();
    const change = new Vector3(0, 0, event.deltaY);
    change.applyQuaternion(rotation);
    newPosition.add(change);
    camera.position.set(
      newPosition.x,
      newPosition.y,
      newPosition.z,
    );
  });
}
